// Implement useMissingTestHook
import { useEffect } from 'react';

import { useMissingDataHeader } from '@/context/MissingDataHeaderProvider';

type Test = {
  executionInfo?: {
    lastRunStatus?: string | null;
  } | null;
};

export type AppliedData = {
  tests: (Test | null)[] | null;
};

export const useSetMissingTests = (appliedData: AppliedData | null | undefined) => {
  const { setMissingTestResults } = useMissingDataHeader();

  useEffect(() => {
    const hasTests = !!appliedData && (appliedData.tests?.length ?? 0) > 0;
    const isMissingTestResults =
      hasTests &&
      (appliedData.tests || []).every(
        (test) => test?.executionInfo?.lastRunStatus == null,
      );
    setMissingTestResults(isMissingTestResults);
    return () => {
      setMissingTestResults(false);
    };
  }, [setMissingTestResults, appliedData]);
};
